const dict = {
  uk: {
    tabPresentations: 'Презентації',
    tabHomework: 'Домашні завдання',
    tabLessons: 'Урок',
    tabAccessRequests: 'Запити доступу',
    myPresentations: 'Мої презентації',
    myHomework: 'Мої домашні завдання',
    myLessons: 'Мої уроки',
    createLesson: 'Створити урок',
    createLessonBtn: 'Створити',
    createGamesBtn: 'Створити ігри',
    editGames: 'Ігри',
    newLessonHeading: 'Новий урок',
    editLessonHeading: 'Редагувати урок',
    lessonTitleLabel: 'Назва уроку',
    lessonTitlePlaceholder: 'Наприклад: Повторення past simple',
    lessonTitleRequired: 'Введіть назву уроку',
    lessonDescriptionLabel: 'Опис (необовʼязково)',
    lessonDescriptionPlaceholder: 'Короткий опис уроку',
    lessonPresentationLabel: 'Презентація',
    lessonHomeworkLabel: 'Домашнє завдання',
    pickPresentation: '— Не обрано —',
    pickHomework: '— Без ДЗ —',
    noPresentation: 'Презентацію не обрано',
    noHomeworkBound: 'ДЗ не привʼязано',
    gamesCount: 'Ігор: {{count}}',
    emptyLessons: 'У вас ще немає власних уроків. Натисніть "Створити урок".',
    deleteLessonTitle: 'Видалити урок?',
    deleteLessonMessage: '«{{title}}» буде видалено разом з привʼязаними іграми.',
    create: 'Створити',
    edit: 'Редагувати',
    linkHomework: 'Прив\'язати ДЗ',
    slidesCount: '{{count}} слайдів',
    exercisesAndPoints: '{{count}} вправ • {{points}} балів',
    emptyPresentations: 'У вас ще немає власних презентацій. Натисніть "Створити".',
    emptyHomework: 'У вас ще немає створених ДЗ. Натисніть "Створити".',
    rename: 'Перейменувати',
    preview: 'Попередній перегляд',
    linkHomeworkTooltip: 'Прив\'язати ДЗ, що автоматично відправиться після уроку',
    homeworkBound: 'Прив\'язано ДЗ',
    editAccessRequests: 'Запити на редагування',
    refresh: 'Оновити',
    noRequests: 'Поки що немає запитів.',
    approve: 'Затвердити',
    reject: 'Відхилити',
    revoke: 'Відкликати доступ',
    grantAccess: 'Надати доступ',
    grantDuration: 'Тривалість доступу',
    grant15min: '15 хв',
    grant30min: '30 хв',
    grant1h: '1 год',
    grant4h: '4 год',
    grant12h: '12 год',
    grant24h: '24 год',
    grantForever: 'Назавжди',
    forever: 'Безстроковий доступ',
    expiresAt: 'Закінчиться {{when}}',
    requestedBy: 'від {{name}}',
    presentationLabel: 'Презентація',
    adminLabel: 'Адмін',
    bindHomeworkTitle: 'Прив\'язати домашнє завдання',
    bindHomeworkDescription: 'Це ДЗ буде автоматично відправлено учню після завершення уроку з цією презентацією.',
    noHomework: '— Без ДЗ —',
    statusRejected: 'Відхилено',
    statusRevoked: 'Відкликано',
    statusExpired: 'Завершено',
    deleteTitle: 'Видалити презентацію?',
    deleteMessage: '«{{title}}» буде видалено разом із прив\'язкою до ДЗ.',
    deleteHomeworkTitle: 'Видалити ДЗ?',
    deleteHomeworkMessage: '«{{title}}» буде видалено. Якщо воно прив\'язане до презентації, прив\'язка скинеться.',
    saveFailed: 'Не вдалося зберегти',
    grantFailed: 'Не вдалося надати доступ',
    defaultTitle: 'Нова презентація',
    previewSlideOf: 'Слайд {{current}} з {{total}}',
    previewSlideTitle: 'Слайд {{n}}',
    previewTeacherNotes: 'Нотатки до слайда',
    previewTeacherNotesHeader: 'Нотатки (видно лише вам)',
    previewDragHint: 'Перетягніть',
    previewCheck: 'Перевірити',
    previewTryAgain: 'Спробувати ще',
    previewCorrect: 'Правильно!',
    previewSomeIncorrect: 'Не всі правильні',
  },
  en: {
    tabPresentations: 'Presentations',
    tabHomework: 'Homework',
    tabLessons: 'Lesson',
    tabAccessRequests: 'Access requests',
    myPresentations: 'My presentations',
    myHomework: 'My homework',
    myLessons: 'My lessons',
    createLesson: 'Create lesson',
    createLessonBtn: 'Create',
    createGamesBtn: 'Create games',
    editGames: 'Games',
    newLessonHeading: 'New lesson',
    editLessonHeading: 'Edit lesson',
    lessonTitleLabel: 'Lesson title',
    lessonTitlePlaceholder: 'e.g. Past simple review',
    lessonTitleRequired: 'Please enter a title',
    lessonDescriptionLabel: 'Description (optional)',
    lessonDescriptionPlaceholder: 'Short description of the lesson',
    lessonPresentationLabel: 'Presentation',
    lessonHomeworkLabel: 'Homework',
    pickPresentation: '— Not selected —',
    pickHomework: '— No homework —',
    noPresentation: 'No presentation selected',
    noHomeworkBound: 'No homework linked',
    gamesCount: 'Games: {{count}}',
    emptyLessons: 'No lessons yet. Click "Create lesson".',
    deleteLessonTitle: 'Delete lesson?',
    deleteLessonMessage: '"{{title}}" will be deleted together with its games.',
    create: 'Create',
    edit: 'Edit',
    linkHomework: 'Link homework',
    slidesCount: '{{count}} slides',
    exercisesAndPoints: '{{count}} exercises • {{points}} points',
    emptyPresentations: 'You have no presentations yet. Click "Create".',
    emptyHomework: 'You have no homework yet. Click "Create".',
    rename: 'Rename',
    preview: 'Preview',
    linkHomeworkTooltip: 'Link homework to be sent automatically after the lesson',
    homeworkBound: 'Homework linked',
    editAccessRequests: 'Edit requests',
    refresh: 'Refresh',
    noRequests: 'No requests yet.',
    approve: 'Approve',
    reject: 'Reject',
    revoke: 'Revoke access',
    grantAccess: 'Grant access',
    grantDuration: 'Access duration',
    grant15min: '15 min',
    grant30min: '30 min',
    grant1h: '1 h',
    grant4h: '4 h',
    grant12h: '12 h',
    grant24h: '24 h',
    grantForever: 'Forever',
    forever: 'Unlimited access',
    expiresAt: 'Expires {{when}}',
    requestedBy: 'from {{name}}',
    presentationLabel: 'Presentation',
    adminLabel: 'Admin',
    bindHomeworkTitle: 'Link homework',
    bindHomeworkDescription: 'This homework will be sent to the student automatically after the lesson with this presentation ends.',
    noHomework: '— No homework —',
    statusRejected: 'Rejected',
    statusRevoked: 'Revoked',
    statusExpired: 'Expired',
    deleteTitle: 'Delete presentation?',
    deleteMessage: '"{{title}}" will be deleted together with its homework binding.',
    deleteHomeworkTitle: 'Delete homework?',
    deleteHomeworkMessage: '"{{title}}" will be deleted. If it is linked to a presentation, the link will be cleared.',
    saveFailed: 'Failed to save',
    grantFailed: 'Failed to grant access',
    defaultTitle: 'New presentation',
    previewSlideOf: 'Slide {{current}} of {{total}}',
    previewSlideTitle: 'Slide {{n}}',
    previewTeacherNotes: 'Slide notes',
    previewTeacherNotesHeader: 'Notes (only you see them)',
    previewDragHint: 'Drag',
    previewCheck: 'Check',
    previewTryAgain: 'Try again',
    previewCorrect: 'Correct!',
    previewSomeIncorrect: 'Some are incorrect',
  },
};

export default dict;
